import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { normalizeExternalUrl } from '@/utils/externalUrl';

export const BannerEditForm = ({ banner, onSave, onCancel }) => {
  const [title, setTitle] = useState(banner.title || '');
  const [imageUrl, setImageUrl] = useState(banner.image_url || '');
  const [linkUrl, setLinkUrl] = useState(banner.link_url || '');

  return (
    <div className="space-y-4">
      <div className="aspect-[4/1] bg-[#0F172A] rounded overflow-hidden flex items-center justify-center p-4">
        <img src={imageUrl} alt="" className="max-h-full max-w-full object-contain" />
      </div>
      <div>
        <Label>Företagsnamn</Label>
        <Input value={title} onChange={(e) => setTitle(e.target.value)} className="mt-1" />
      </div>
      <div>
        <Label>Logotyp (URL)</Label>
        <Input value={imageUrl} onChange={(e) => setImageUrl(e.target.value)} className="mt-1" />
      </div>
      <div>
        <Label>Webbplats vid klick</Label>
        <Input
          value={linkUrl}
          onChange={(e) => setLinkUrl(e.target.value)}
          placeholder="www.abkarlhedin.se"
          className="mt-1"
        />
        <p className="text-xs text-gray-500 mt-1">https:// läggs till automatiskt om det saknas.</p>
      </div>
      <div className="flex gap-2 justify-end">
        <Button variant="outline" onClick={onCancel}>Avbryt</Button>
        <Button
          className="bg-[#003B73]"
          onClick={() =>
            onSave({
              title,
              image_url: imageUrl,
              link_url: normalizeExternalUrl(linkUrl),
            })
          }
        >
          Spara
        </Button>
      </div>
    </div>
  );
};
